module.exports = __webpack_public_path__ + "static/media/electranet.1b6bd296.png";